import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {Oktoberfest} from "../Oktoberfest";
import {TimelineLite} from "gsap";
import {OktoberfestSound} from "../sound/OktoberfestSound";
import {Layers, OktoberfestLayers} from "./OktoberfestLayers";


export class OktoberfestStackedWildsWPView extends PIXI.Container {

    private _W1_girlStart_anim: TimelineSprite;
    private _W1_girlCheering_anim: TimelineSprite;
    private _W1_girlDrinking_anim: TimelineSprite;
    private _W2_guyStart_anim: TimelineSprite;
    private _W2_guyCheering_anim: TimelineSprite;
    private _W2_guyDrinking_anim: TimelineSprite;
    private _waitForWildLanding: number = 1.5;

    constructor() {
        super();
        this.init();
        OktoberfestLayers.getLayer(Layers.STACK_ANIMS)!.addChild(this);
    }

    public startAnimation(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const  girlStartDuration:number =this._W1_girlStart_anim.totalDuration;
        const  guyStartDuration:number =this._W2_guyStart_anim.totalDuration;
        const pauseBeforeCheer:number =0.1;
        const cheerDuration:number =this._W1_girlCheering_anim.totalDuration;
        const drinkingDuration:number =this._W2_guyDrinking_anim.totalDuration;
        this._W1_girlStart_anim.hide();
        OktoberfestSound.playSoundEffect(OktoberfestSound.SOUND_NAME_WOMAN_APPEARS);
        tl.add(this._W1_girlStart_anim.getAnimationAutoShowHide(true, false));
        tl.add([
            this._W2_guyStart_anim.getAnimationAutoShowHide(true, false, [0], () => {
            }, () => {
                this._W1_girlCheering_anim.show();
                this._W2_guyCheering_anim.show();
                this._W1_girlStart_anim.hide();
                this._W2_guyStart_anim.hide();
            }),
            () => {
                OktoberfestSound.playSoundEffect(OktoberfestSound.SOUND_NAME_MAN_APPEARS);
            }
        ], girlStartDuration);
        tl.add([
            this._W2_guyCheering_anim.getAnimationAutoShowHide(true, false),
            this._W1_girlCheering_anim.getAnimationAutoShowHide(true, false, [0], () => {
            }, () => {
            })], girlStartDuration+guyStartDuration+pauseBeforeCheer);
        tl.add(()=>{
            Oktoberfest.reels[2].getSymbol(0).visible = false;
            Oktoberfest.nudgeWild.startAnimation();
            OktoberfestSound.playSoundEffect(OktoberfestSound.SOUND_NAME_CHEERS);
        }, girlStartDuration+guyStartDuration+0.25);
        tl.add([
            () => {
                this._W1_girlDrinking_anim.show();
                this._W2_guyDrinking_anim.show();
                this._W1_girlCheering_anim.hide();
                this._W2_guyCheering_anim.hide();
                this._W1_girlDrinking_anim.getAnimationAutoShowHide(true, false);
                this._W2_guyDrinking_anim.getAnimationAutoShowHide(true, false);
            },
        ], girlStartDuration +guyStartDuration+ 0.2 + cheerDuration+ this._waitForWildLanding);
        tl.add(() => {
            this._W1_girlDrinking_anim.hide();
            this._W2_guyDrinking_anim.hide();
        }, tl.totalDuration() + 0.2 + drinkingDuration+0.5);
        return tl;
    }

    private init(): void {
        this._W1_girlStart_anim = this.createAnimation("W1_1");
        this._W1_girlCheering_anim = this.createAnimation("W1_2");
        this._W1_girlStart_anim.x = 214;
        this._W1_girlCheering_anim.x = 242;
        this._W1_girlCheering_anim.y = this._W1_girlStart_anim.y = 370;
        this._W2_guyStart_anim = this.createAnimation("W2_1");
        this._W2_guyCheering_anim = this.createAnimation("W2_2");
        this._W2_guyCheering_anim.x = this._W2_guyStart_anim.x = 523;
        this._W2_guyCheering_anim.y = this._W2_guyStart_anim.y = 344;


        this._W1_girlDrinking_anim = this.createAnimation("W1_3");
        this._W2_guyDrinking_anim = this.createAnimation("W2_3");
        this._W1_girlDrinking_anim.x = this._W1_girlCheering_anim.x;
        this._W1_girlDrinking_anim.y = this._W1_girlCheering_anim.y;
        this._W2_guyDrinking_anim.x = this._W2_guyCheering_anim.x;
        this._W2_guyDrinking_anim.y = this._W2_guyCheering_anim.y;
    }

    private createAnimation(texture: string): TimelineSprite {
        const animation = new TimelineSprite(Oktoberfest.assetLoader.getTextures(texture));
        animation.anchor.set(0.5);
        this.addChild(animation);
        animation.hide();
        return animation;
    }
}
